import { render, staticRenderFns } from "./primaryCategory.vue?vue&type=template&id=fce6145a&scoped=true&"
import script from "./primaryCategory.vue?vue&type=script&lang=js&"
export * from "./primaryCategory.vue?vue&type=script&lang=js&"
import style0 from "./primaryCategory.vue?vue&type=style&index=0&id=fce6145a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce6145a",
  null
  
)

export default component.exports